export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 48 48" fill="none" className={className} aria-hidden="true">
    <path d="M27 13 C27 6.5 31 2.5 37.5 2.5 C37.5 9 33 13 27 13 Z" fill="#71824F" />
    <path d="M29 14.5 C31.5 9.5 36.5 8 42 10 C40.5 15.5 35 17.5 29 14.5 Z" fill="#93A56B" />
    <clipPath id="gg-bean">
      <ellipse cx="23" cy="27.5" rx="14.5" ry="17" />
    </clipPath>
    <ellipse cx="23" cy="27.5" rx="14.5" ry="17" fill="#4A2A18" />
    <g clipPath="url(#gg-bean)">
      <rect x="20" y="9" width="6.5" height="37" rx="3" fill="#F3E6C8" />
      <rect x="20" y="15.5" width="6.5" height="2.2" fill="#4A2A18" />
      <rect x="20" y="21.5" width="6.5" height="2.2" fill="#4A2A18" />
      <rect x="20" y="27.5" width="6.5" height="2.2" fill="#4A2A18" />
      <rect x="20" y="33.5" width="6.5" height="2.2" fill="#4A2A18" />
      <rect x="20" y="39.5" width="6.5" height="2.2" fill="#4A2A18" />
    </g>
  </svg>
);

export const Logo = ({ dark = false }) => (
  <a href="/" data-testid="logo-link" className="flex items-center gap-2.5 group">
    <LogoMark className="w-9 h-9 transition-transform duration-500 group-hover:rotate-[8deg]" />
    <span className={`font-display font-extrabold text-xl tracking-tight ${dark ? "text-[#FAF9F6]" : "text-[#0B1E17]"}`}>
      Give <span className="text-[#D97706]">&amp;</span> Grind
    </span>
  </a>
);
